// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"styles_linkContainer__3b4oS","link":"styles_link__HICze","desktopHide":"styles_desktopHide__ptVLO","mobileHide":"styles_mobileHide__2PRw-"};